import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Template from './template';
import { editNotificationSettings } from '../../../stores/user/user-actions';
import { options } from '../notificationOptions';
import R from 'ramda';

const checkAssetReceivingSettings = (direct, settings, notifications) => {
  return settings.every(s => {
    if (s.settings) return checkAssetReceivingSettings(direct, s.settings, notifications);
    const value = R.path([s.type, s.key], notifications) || [];
    return direct ? value.indexOf('noDirect') === -1 : value.indexOf('email') > -1;
  });
};

class Notifications extends Component {
  render() {
    const { notifications, editNotifications, plan, locAccess, corporateContractingAccess, companyType } = this.props;

    const sharedProps = {
      updateNotification: (type, value) => editNotifications(R.merge(notifications, { [type]: R.merge(notifications[type], value) })),
    };

    const isPaidUser = plan === 'connected' || plan === 'unlimited';
    const hasContractingAccess = R.call(R.compose(
      R.complement(R.isEmpty),
      R.concat(corporateContractingAccess),
      R.chain(R.prop('contracting'))
    ), locAccess);
    const toggleAll = direct => (_, toggled) => {
      const assetReceivingOption = options(true, isPaidUser, companyType, hasContractingAccess)[2];
      const obj = {};
      const updateSetting = s => {
        const value = R.path([s.type, s.key], notifications) || [];
        obj[s.type] = obj[s.type] || {};
        if (direct) {
          obj[s.type][s.key] = toggled ? value.filter(x => x !== 'noDirect') : [...value, 'noDirect'];
        } else {
          obj[s.type][s.key] = toggled ? [...value, 'email'] : value.filter(x => x !== 'email');
        }
      };
      assetReceivingOption.settings.forEach(s => {
        if (s.settings) {
          s.settings.forEach(updateSetting);
        } else {
          updateSetting(s);
        }
      });
      editNotifications(obj);
    };
    return (
      <div>
        <div style={{ fontSize: '26px', fontWeight: 400, marginTop: '4px', paddingBottom: '12px', borderBottom: '1px solid #e6e9ec' }}>
          Notifications
        </div>
        <div style={{ margin: '0 5px 0 10px' }}>
          {
            options(true, isPaidUser, companyType, hasContractingAccess).map((option, i) => {
              const allDirectChecked = option.assetReceiving
                ? checkAssetReceivingSettings(true, option.settings, notifications) : false;
              const allIndirectChecked = option.assetReceiving
                ? checkAssetReceivingSettings(false, option.settings, notifications) : false;
              return (
                <Template
                  key={i}
                  {...sharedProps}
                  {...option}
                  notifications={notifications}
                  allDirectChecked={allDirectChecked}
                  allIndirectChecked={allIndirectChecked}
                  toggleAllDirect={toggleAll(true)}
                  toggleAllIndirect={toggleAll(false)}
                />
              );
            })
          }
        </div>
      </div>
    );
  }
}

Notifications.propTypes = {
  notifications: PropTypes.object,
  editNotifications: PropTypes.func,
  plan: PropTypes.string,
  companyType: PropTypes.string,
  locAccess: PropTypes.array,
  corporateContractingAccess: PropTypes.array,
};

const mapStateToProps = ({ user }) => ({
  notifications: user.get('notifications'),
  plan: user.get('billingPlan'),
  locAccess: user.get('locAccess'),
  corporateContractingAccess: user.get('corporateContractingAccess'),
  companyType: user.getIn(['user', 'type']),
});

const mapDispatchToProps = dispatch => ({
  editNotifications: (...args) => dispatch(editNotificationSettings(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/app/components/settings/notifications/container.jsx